module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "reset-view right_auth"
  }, [_c('div', {
    staticClass: "theme"
  }, [_vm._v("\n        修改密码\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "form_modal"
  }, [_c('p', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.remote))]), _vm._v(" "), _c('div', {
    staticClass: "form_ctr"
  }, [_c('p', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.old.error))]), _vm._v(" "), _c('label', {
    staticClass: "req"
  }, [_vm._v("旧密码")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.old.model),
      expression: "old.model"
    }],
    staticClass: "w200",
    attrs: {
      "input": "text",
      "onfocus": "this.type='password'"
    },
    domProps: {
      "value": (_vm.old.model)
    },
    on: {
      "blur": _vm.required,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.old, "model", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form_ctr"
  }, [_c('p', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.pwd.error))]), _vm._v(" "), _c('label', {
    staticClass: "req"
  }, [_vm._v("新密码")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pwd.model),
      expression: "pwd.model"
    }],
    staticClass: "w200",
    attrs: {
      "input": "text",
      "onfocus": "this.type='password'"
    },
    domProps: {
      "value": (_vm.pwd.model)
    },
    on: {
      "blur": _vm.password,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.pwd, "model", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form_ctr"
  }, [_c('p', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.certain.error))]), _vm._v(" "), _c('label', {
    staticClass: "req"
  }, [_vm._v("确认密码")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.certain.model),
      expression: "certain.model"
    }],
    staticClass: "w200",
    attrs: {
      "input": "text",
      "onfocus": "this.type='password'"
    },
    domProps: {
      "value": (_vm.certain.model)
    },
    on: {
      "blur": _vm.confirm,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.certain, "model", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "error"
  })]), _vm._v(" "), _c('ul', {
    staticClass: "btn",
    staticStyle: {
      "margin-top": "10px",
      "margin-left": "-85px"
    }
  }, [_c('li', {
    on: {
      "click": _vm.reset
    }
  }, [_vm._v("提交")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5d9feee8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/ResetView.vue
// module id = 863
// module chunks = 1